var React = require('react');

function Content (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M33.6588 11.2894V26.9694H3.68234V11.2894H33.6588ZM37.1176 7.83057H0.223511V30.4282H37.1176V7.83057Z","fill":"#34363E","key":0}),React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M15.4423 3.56478C14.7833 3.56478 14.174 4.17402 14.174 4.83302V9.90596H10.7152V4.83302C10.7152 2.26378 12.873 0.105957 15.4423 0.105957H21.6682C24.2374 0.105957 26.3952 2.26377 26.3952 4.83302V9.90596H22.9364V4.83302C22.9364 4.17403 22.3271 3.56478 21.6682 3.56478H15.4423Z","fill":"#34363E","key":1})]);
}

Content.defaultProps = {"width":"38","height":"31","viewBox":"0 0 38 31","fill":"none"};

module.exports = Content;

Content.default = Content;
